module.exports = __webpack_public_path__ + "img/sponsoren-logos.c6d3e8eb.jpg";